module.exports = __webpack_public_path__ + "assets/img/673b-lr.svg";